import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';

@Component({
    selector: 'logo-widget',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './logowidget.component.html'
})
export class LogoWidget {
    @Input() width: number | string = 253;
    @Input() height: number | string = 76;

    private layoutService = inject(LayoutService);

    get isDark(): boolean {
        return this.layoutService.isDarkTheme();
    }
}
